const validateEmail = (email: string) => {
  const validateBusinessEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^[a-zA-Z0-9._%+-]+@(?!gmail)(?!yahoo)(?!hotmail)(?!aol)(?!live)(?!outlook)[a-zA-Z0-9_-]+.[a-zA-Z0-9-.]{2,61}$/
      );
  };

  const checkIfEmailHasTwoDomain = (email) => {
    console.log({
      email,
    });
    // return email.split(".").length > 2;
    const subDomain = email.split("@")[1];

    return subDomain.split(".").length > 2;
  };

  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    )
    ? validateBusinessEmail(email)
    : false;
};
export default validateEmail;
